import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-table-pagination',
  imports: [CommonModule],
  templateUrl: './table-pagination.html',
  styleUrl: './table-pagination.css',
})
export class TablePagination {
  @Input() page = 1;
  @Input() pageSize = 10;
  @Input() totalItems = 0;
  @Input() itemLabel = 'registros';
  @Input() pageSizeOptions: number[] = [10, 20, 30, 40, 50];

  @Output() pageChange = new EventEmitter<number>();
  @Output() pageSizeChange = new EventEmitter<number>();

  get totalPages(): number {
    return Math.max(1, Math.ceil(this.totalItems / this.pageSize));
  }

  get safePage(): number {
    return Math.min(Math.max(this.page, 1), this.totalPages);
  }

  get firstItem(): number {
    if (this.totalItems === 0) return 0;
    return (this.safePage - 1) * this.pageSize + 1;
  }

  get lastItem(): number {
    return Math.min(this.safePage * this.pageSize, this.totalItems);
  }

  get isFirstPage(): boolean {
    return this.safePage <= 1;
  }

  get isLastPage(): boolean {
    return this.safePage >= this.totalPages;
  }

  onPageSizeChange(event: Event): void {
    const select = event.target as HTMLSelectElement;
    const value = Number(select.value);
    if (!Number.isFinite(value) || value <= 0) return;
    this.pageSizeChange.emit(value);
  }

  goPrevious(): void {
    if (this.isFirstPage) return;
    this.pageChange.emit(this.safePage - 1);
  }

  goNext(): void {
    if (this.isLastPage) return;
    this.pageChange.emit(this.safePage + 1);
  }
}
